
import axios from '@/plugins/axiosPlugins'

import runEvn from '@/modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * 获取首页顶部 统计
 * @param data 
 * @returns 
 */
export const getNeighborHomeTotal = (): Promise<any> => {
    return axios.get(`${baseURL}/NeighborHome/GetNeighborHomeTotal`)
}
/**
 * 睦邻搜索
 * @param data 
 * @returns 
 */
export const getNeighborSearch = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/NeighborHome/Search`, { params: data })
}

/**
 * 睦邻捐赠列表
 * @param data 
 * @returns 
 */
export const GetDonationData = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/NeighborHome/GetDonationData`, { params: data })
} 

/**
 * GetServiceTimeData
 * @param data 
 * @returns 
 */
export const GetServiceTimeData = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/NeighborHome/GetServiceTimeData`, { params: data })
} 